import { useMutation } from 'react-query'
import { api } from '../../../api'

const removeAssetAnalyst = async (id: number): Promise<void> => {
  return await api.delete(`/asset-analysts/${id}`)
}

export const useAssetAnalystRemoveMutation = () => {
  return useMutation('remove-asset', async (id: number) => removeAssetAnalyst(id))
}
